// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"204":"e78dc6286b2907a5","837":"415c3a20d745a03e"}[chunkId] + ".js";
};